import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { Wish } from './models/wishes'

firebase.initializeApp({
  apiKey: 'AIzaSyBCqf2xR_eKUKqPEMkjcNmMD7LBC6hvagk',
  authDomain: 'jetztein.firebaseapp.com',
  databaseURL: 'https://jetztein.firebaseio.com',
  projectId: 'jetztein',
  storageBucket: 'jetztein.appspot.com',
  messagingSenderId: '586941678976',
})

// Initialize Cloud Firestore through Firebase
export const db = firebase.firestore()

// Disable deprecated features
db.settings({
  timestampsInSnapshots: true,
})

export function addWish(wish: Wish) {
  return db.collection('wish').add(wish)
}

export function addUser(user: any) {
  return db.collection('user').add(user)
}

export function addVote(vote: any) {
  return db.collection('vote').add(vote)
}

export async function getWishes(): Promise<Wish[]> {
  const wishes = await db.collection('wish').get()

  return Promise.all(
    wishes.docs.map(async function(wish: any) {
      const voteSnapshots = await db
        .collection('vote')
        .where('wishId', '==', wish.id)
        .get()

      return {
        id: wish.id,
        ...wish.data(),
        votes: voteSnapshots.docs,
      }
    })
  )
}



// WEBPACK FOOTER //
// ./src/db.ts